import React, { memo, useContext } from "react";
import { ObjectContext } from "@providers/ObjectProvider";
import Box from "@mui/joy/Box";
import ChecklistRoundedIcon from '@mui/icons-material/ChecklistRounded';
import Diversity3RoundedIcon from '@mui/icons-material/Diversity3Rounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import ObjectRelationshipCard from "@components/objects/ObjectRelationshipCard";
import ObjectRelationshipTable from "@components/objects/ObjectRelationshipTable";
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import { generateAddress } from "@utils/generateAddress";
import ObjectPreview from "./ObjectPreview";
import { formatDate, formatTime, isValidDate } from "@utils/dates";
import { formatCurrency } from "@utils/numbers";
import ObjectRelationshipNotes from "./ObjectRelationshipNotes";
import ObjectRelationshipUserTasks from "./ObjectRelationshipUserTasks";
import ObjectRelationshipInvolvements from "./ObjectRelationshipInvolvements";
import ObjectRelationshipFiles from "./ObjectRelationshipFiles";
import { yesNo } from "@utils/yesNo";
import ObjectRelationshipTasksEdit from "./ObjectRelationshipTasksEdit";
import ObjectRelationshipHours from "./ObjectRelationshipHours";
import { FauxTable, FauxTableRow } from "@components/FauxTable";
import { Button, IconButton, Tooltip, Typography } from "@mui/joy";
import { EventDate } from "@components/EventDate";
import { useFormContext } from "react-hook-form";
import ObjectRelationshipTableEdit from "./ObjectRelationshipTableEdit";
import { relationshipRoles } from "@utils/selectOptions";
import ObjectRelationshipNotesEdit from "./ObjectRelationshipNotesEdit";
import { ObjectRelationship } from "./ObjectRelationship";
import { useAuth } from "@providers/AuthProvider";
import FileUploadTest from "@components/FileUploadTest";
import ObjectRelationshipFilesEdit from "./ObjectRelationshipFilesEdit";
import ObjectRelationshipHoursEdit from "./ObjectRelationshipHoursEdit";
import ObjectRelationshipEmployeesEdit from "./ObjectRelationshipEmployeesEdit";
import { supportedRelationships } from "@api/schema/supportedRelationships";
import { propertiesRelationship } from "@api/schema/propertiesRelationship";
import { businessesRelationship } from "@api/schema/businessesRelationship";
import { useRenderCount } from "@uidotdev/usehooks";

export const ObjectRelationshipEdit = memo(function ObjectRelationshipEdit({ type, permissions = null, mutator = null, column = null, ...restProps }) {
    // console.debug(`ObjectRelationshipEdit ${type} was rendered at`, new Date().toLocaleTimeString());
    // const renders = useRenderCount();
    // console.debug(`renders ${type}`, renders);

    const { can } = useAuth();
    {/* const data = useContext(ObjectContext); */}
    // const { getValues/*, watch*/ } = useFormContext();

    // this will display the show screen if the doesn't have the correct permission to edit
    // it can be disabled by adding revert={false}
    if(/*permissions !== true && permissions !== null &&*/ !can(permissions)) {
        if(restProps.revert === false) {
            return null;
        }
        return (
            <ObjectRelationship
                type={type}
                // permissions={permissions} // this will never render
                column={column}
                {...restProps}
            />
        );
    }

    const columnToCheck = column ?? type;
    // const data = getValues();

    // const rawRelationship = data[columnToCheck];
    // const relationship = typeof mutator === 'function' ? mutator(data) : rawRelationship;

    const displayType = supportedRelationships?.[type+'_edit'] ?? supportedRelationships[type];

    if(!displayType) {
        return <em>not supported: {type}</em>
    }

    if(
        restProps.hasOwnProperty('visible')
        && !restProps.visible(getValues())
    ) {
        return null;
    }

    // Standard relationships
    if(displayType.type === 'table') {
        return (
            <ObjectRelationshipTableEdit
                {...displayType}
                relationship={columnToCheck}
            />
        );
    }

    /*
    if(displayType.type === 'involvements') {
        return (
            <ObjectRelationshipInvolvements
                {...displayType}
                relationship={columnToCheck}
            />
        );
    }
    */

    /*
    if(displayType.type === 'files') {
        return (
            <FileUploadTest />
        );
    }
    */

    if(displayType.type === 'files') {
        return (
            <ObjectRelationshipFilesEdit
                {...displayType}
                relationship={columnToCheck}
                {...restProps}
            />
        );
    }

    if(displayType.type === 'notes' || displayType.type === 'richtext') {
        return (
            <ObjectRelationshipNotesEdit
                {...displayType}
                column={column}
                relationship={columnToCheck}
                {...restProps}
            />
        )
    }

    /*
    if(displayType.type === 'workplan_tasks') {
        return (
            <ObjectRelationshipUserTasks
                {...displayType}
                relationship={columnToCheck}
            />
        )
    }
    */

    if(displayType.type === 'tasks') {
        return (
            <ObjectRelationshipTasksEdit
                {...displayType}
                relationship={columnToCheck}
            />
        )
    }

    if(displayType.type === 'hours') {
        return (
            <ObjectRelationshipHoursEdit
                {...displayType}
                relationship={columnToCheck}
            />
        )
    }

    if(displayType.type === 'employees') {
        return (
            <ObjectRelationshipEmployeesEdit
                {...displayType}
                relationship={columnToCheck}
            />
        )
    }

    return <em>not yet implemented {type}</em>
});
